import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/blade-resource/oss/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getDetail = id => request({
  url: '/api/blade-resource/oss/detail',
  method: 'get',
  params: {
    id,
  },
})
export const getAttachDetail = id => request({
  url: '/api/blade-resource/attach/detail',
  method: 'get',
  params: {
    id,
  },
})
export const remove = ids => request({
  url: '/api/blade-resource/oss/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-resource/oss/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-resource/oss/submit',
  method: 'post',
  data: row,
})

export const enable = id => request({
  url: '/api/blade-resource/oss/enable',
  method: 'post',
  params: {
    id,
  },
})

export const putFile = backgroundUrl => request({
  url: '/api/blade-resource/oss/endpoint/put-file',
  method: 'post',
  params: {
    backgroundUrl,
  },
})
